import { API } from '../Api';

// Feed "ai vừa trúng/mua vật phẩm gì" — dùng cho slider khoe quà.
const base = '/v1/payment-service/reward-feed';

export interface RewardFeedItem {
  displayName: string;
  kind: 'win' | 'purchase';
  itemName: string;
  rarity: string; // Common..Mythic
  itemType: string; // Nametag | AvatarEffect
  source: string; // "VIP Box" | "Cửa hàng"...
  occurredAt: string;
}

export const getRewardFeed = (take = 20) =>
  API.get<RewardFeedItem[]>(`${base}?take=${take}`).then((r) => r.data);
